import { api } from "./api";

/**
 * HoloSticker Market API client (Fase 6).
 *
 * NEVER throws for the happy path — errors surface via api's Axios error
 * objects. Callers should catch and format via `formatApiError` from `./api`.
 */
export const marketApi = {
  list: async () => {
    const { data } = await api.get("/market/packs");
    return Array.isArray(data) ? data : [];
  },
  purchase: async (packId) => {
    const { data } = await api.post(`/market/packs/${encodeURIComponent(packId)}/purchase`);
    return data; // { ok, pack_id, balance, purchased_at }
  },
};

/** Public price constant — mirrors backend STICKER_PACK_PRICE. */
export const STICKER_PACK_PRICE = 25;
